import { Tooltip } from "antd";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { ACTION_BTN_HOVER_CLR } from "@/Constants/common";
import { toggleOurServiceModal } from "@/reducers/clientcommon";
import {
  fetchApplicantLists,
  updateActiveContract,
  updateApplicantsPagination,
  updateContractStatus,
  updateToggleSelected,
} from "@/reducers/clientcontractdetail";
import {
  _approveCandidate,
  _rejectCandidate,
} from "@/services/clientcandidates";
import { TOOLTIPTEXT, toastMessageText } from "@/utilities/CommonText";
import {
  handleAPICatch,
  showCommonToast,
  showSuccessToast,
} from "@/utilities/utils";

import RunningLateIcon from "../../../Icons/RunningLateIcon";
import ActionIcons from "../ActionIcons";
import NotAllowedButtonWrapper from "../managedService/NotAllowedButtonWrapper";

/**
 * This function represents a contract listing type component.
 *
 * @return {JSX.Element} The JSX component for the contract listing type.
 */
const ContractListingType = () => {
  const {
    contractId,
    applicantsPagination,
    activeContract,
    isLoading,
    contractDetails,
    selectedApplication,
    contractApplicantsLists,
    filters,
    runningLateContract,
  } = useSelector((state) => state.clientContractDetail);
  const [approveLoading, setApproveLoading] = useState(false);
  const [rejectLoading, setRejectLoading] = useState(false);
  const { isPremiumAccount, clientUserAllPermissions } = useSelector(
    (state) => state.session,
  );
  const { user } = useSelector((state) => state.clientProfile);
  const dispatch = useDispatch();
  const isNotBooked =
    contractDetails.contract_status === "Applied" ||
    contractDetails.contract_status === "Published";

  const hasRunningLateData =
    (Array.isArray(runningLateContract) && runningLateContract.length > 0) ||
    (typeof runningLateContract === "object" &&
      runningLateContract !== null &&
      Object.keys(runningLateContract).length > 0);

  // console.log("hello", hasRunningLateData)

  const data = [
    {
      name: isNotBooked ? "Applicant’s List" : "Booked",
      type: "applicants",
    },
    {
      name: "Shift List",
      type: "shifts",
    },
    // {
    //   name: "Terminated Shifts",
    //   type: "terminatedShifts",
    // },
    ...(!hasRunningLateData
      ? []
      : [
          {
            name: "Running late",
            type: "runningLateMap",
          },
        ]),
  ];
  const approveRejectCandidate = (data) => {
    const postData = data;
    const _handleFunc =
      data.status === "approve" ? _approveCandidate : _rejectCandidate;
    const response = _handleFunc(postData);
    response
      .then((res) => {
        const {
          data: { data, message },
        } = res;
        showSuccessToast(message);
        dispatch(
          updateApplicantsPagination({
            ...applicantsPagination,
            currentPage: 1,
            isLastPage: false,
          }),
        );
        if (postData.status === "approve") {
          dispatch(updateContractStatus("Booked"));
          dispatch(
            fetchApplicantLists({
              contract_id: contractId,
              search: filters.search,
              contract_status: "Booked",
            }),
          );
        } else {
          dispatch(updateActiveContract("shifts"));
          dispatch(updateContractStatus("Applied"));

          dispatch(
            fetchApplicantLists({
              contract_id: contractId,
              search: filters.search,
            }),
          );
        }
        dispatch(updateToggleSelected());
      })
      .catch((error) => {
        handleAPICatch(error);
      })
      .finally(() => {
        setApproveLoading(false);
        setRejectLoading(false);
      });
  };

  // useEffect(()=>{
  //   // dispatch(updateActiveContract(data[0].type));
  // },[])
  const getListTab = (item) => {
    let isRunningLateActive =
      activeContract === "runningLateMap" && item.type === "runningLateMap";
    return (
      <div
        className={`shiftperiod_item flex h-[40px] min-w-[99px] cursor-pointer select-none items-center justify-center gap-1 rounded-lg p-3 text-base font-medium transition-all duration-200 ease-linear ${isLoading ? "pointer-events-none" : ""} ${isRunningLateActive ? "bg-red-200 !text-red" : activeContract === item.type ? "bg-lightblue text-primary" : "bg-grey text-txtColor"} ${!isPremiumAccount && (item.type === "terminatedShifts" || (isNotBooked && item.type === "applicants" && !user?.client_allow_publish_job)) ? "!cursor-not-allowed opacity-50" : ""} `}
        onClick={() => {
          if (item.type === activeContract) {
            return;
          }
          if (
            (item.type == "terminatedShifts" ||
              (isNotBooked &&
                item.type == "applicants" &&
                !user?.client_allow_publish_job)) &&
            !isPremiumAccount
          ) {
            dispatch(toggleOurServiceModal(true));
            // showManagedServiceToast();
            return;
          }
          dispatch(updateToggleSelected());
          setTimeout(() => {
            dispatch(updateActiveContract(item.type));
          }, 10);
        }}
      >
        {item.type === "runningLateMap" ? (
          <RunningLateIcon
            cls={`${activeContract === "runningLateMap" ? "text-red" : "text-txtColor"} w-[23px] h-[23px] `}
          />
        ) : (
          " "
        )}
        {item.name}
      </div>
    );
  };
  return (
    <div className="ContractListingType_Wrapper">
      <div className="flex gap-3">
        <div className="flex gap-3">
          {data.map((item, index) => {
            if (
              (item.type == "terminatedShifts" ||
                (isNotBooked &&
                  item.type == "applicants" &&
                  !user?.client_allow_publish_job)) &&
              !isPremiumAccount
            ) {
              return (
                <NotAllowedButtonWrapper
                  key={item.id || item.type || index}
                  rootClass="rounded-lg"
                  iconClass="w-[20px] h-[20px] text-primary"
                >
                  {getListTab(item)}
                </NotAllowedButtonWrapper>
              );
            } else if (item.type == "runningLateMap" && !isPremiumAccount) {
              return null;
            }

            return <div key={item.id || index}>{getListTab(item)}</div>;
          })}
        </div>
        {activeContract === "applicants" &&
        contractApplicantsLists.length &&
        (contractDetails.contract_status === "Applied" ||
          contractDetails.contract_status === "Published") ? (
          !clientUserAllPermissions ||
          clientUserAllPermissions.is_allow_to_approve_job ? (
            <>
              <div className="grid h-[40px] cursor-pointer grid-cols-[repeat(2,56px)] overflow-hidden rounded-lg bg-grey [&>*:last-child]:border-r-0 [&>*]:grid [&>*]:place-items-center [&>*]:border-0 [&>*]:border-r [&>*]:border-r-[#E5E6E9] [&>*]:text-txtColor">
                <Tooltip title={TOOLTIPTEXT.approve}>
                  <div
                    className={`group ${ACTION_BTN_HOVER_CLR.green}`}
                    onClick={() => {
                      if (selectedApplication.length > 0) {
                        if (selectedApplication.length > 1) {
                          showCommonToast(
                            "You can not approve multiple candidates",
                            {
                              id: "multiple-candidate-selected",
                            },
                          );
                          return;
                        } else {
                          dispatch(updateToggleSelected());
                          setApproveLoading(true);
                          approveRejectCandidate({
                            applicant_ids: selectedApplication.join(","),
                            status: "approve",
                          });
                        }
                      } else {
                        showCommonToast(toastMessageText.noCandidateSelected, {
                          id: "no-candidate-selected",
                        });
                      }
                    }}
                  >
                    <ActionIcons isLoading={approveLoading} type={"approve"} />
                  </div>
                </Tooltip>
                <Tooltip title={TOOLTIPTEXT.reject}>
                  <div
                    className={`group ${ACTION_BTN_HOVER_CLR.red}`}
                    onClick={() => {
                      if (selectedApplication.length > 0) {
                        dispatch(updateToggleSelected());
                        setRejectLoading(true);
                        approveRejectCandidate({
                          applicant_ids: selectedApplication.join(","),
                          status: "deny",
                          isSelectedAll: false,
                        });
                      } else {
                        showCommonToast(toastMessageText.noCandidateSelected, {
                          id: "no-candidate-selected",
                        });
                      }
                    }}
                  >
                    <ActionIcons isLoading={rejectLoading} type={"reject"} />
                  </div>
                </Tooltip>
              </div>
            </>
          ) : null
        ) : null}
      </div>
    </div>
  );
};

export default ContractListingType;
